/**
 * Auth0 error codes for which silent token retrieval can never succeed again
 * The only recovery is an interactive re-login.
 */
const UNRECOVERABLE_AUTH_ERROR_CODES = ['invalid_grant', 'login_required'];

const isUnrecoverableAuthError = (error: unknown): boolean =>
  typeof error === 'object' &&
  error !== null &&
  'error' in error &&
  UNRECOVERABLE_AUTH_ERROR_CODES.includes((error as { error: string }).error);

export default isUnrecoverableAuthError;
